import { useEffect, useState } from 'react';

/** Top offset for search input + padding (approximate). */
const DROPDOWN_TOP_OFFSET_PX = 140;

/** Max viewport height ratio for dropdown (70%). */

/**
 * Returns max height in px for mobile search dropdown,
 * computed from visualViewport with resize and scroll subscription.
 */
export function useDropdownMaxHeight(): number | null {
  const [maxHeightPx, setMaxHeightPx] = useState<number | null>(null);

  useEffect(() => {
    const viewport = typeof window !== 'undefined' ? window.visualViewport : null;
    if (!viewport) {
      return;
    }

    const updateHeight = () => {
      const vh = viewport.height;
      setMaxHeightPx(
        Math.min(vh - DROPDOWN_TOP_OFFSET_PX),
      );
    };

    updateHeight();
    viewport.addEventListener('resize', updateHeight);
    viewport.addEventListener('scroll', updateHeight);
    return () => {
      viewport.removeEventListener('resize', updateHeight);
      viewport.removeEventListener('scroll', updateHeight);
    };
  }, []);

  return maxHeightPx;
}
